import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { CreateCompanyQuery } from '../../shared/common/graphqlQuery';
import { useMutationHook } from '../../shared/hooks/useMutationHook';
import { companyData } from '../../core/auth';
import { routeConfig } from '../../shared/common/constant';
import Modal from 'antd/lib/modal/Modal';
import { Button, Form, Input, message } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { validateLabelMessages } from '../../shared/hooks/utils';

const layout = {
    labelCol: {
        // span: 8,
    },
    wrapperCol: {
        // span: 16,
    },
};

const CreateCompany = () => {
    const [showsecond, setShowSecond] = useState<boolean>(false);
    const [visibleModal, setVisibleModal] = useState<boolean>(true);
    const history = useHistory();
    const [constvalues, setValues] = useState({});
    const onSubmitted = (result: any) => {
        companyData().saveCompanyData(result.createCompany);
        history.push(routeConfig.companyBank.path);
    }
    
    useEffect(() => {
        if(companyData().isCompanyExist()) {
            message.warn('company already created.');
            history.push(routeConfig.home.path);
        }
    }, []);
    
    const onError = (error: any) => {
        console.log(error, 'mymy');
    }

    const handleCancel = () => {
        setVisibleModal(false);
    }
    const { callMutation, loading } = useMutationHook(CreateCompanyQuery, onSubmitted, onError);

    function onFinish(values) {
        if (showsecond) {
            if(!loading) {
                callMutation({ variables: { createCompanyData: { ...values, ...constvalues } } })
            }
        } else {
            setValues(values)
            setShowSecond(true);
        }
    }

    return (
        <div className="form-wrapper">
            <p>{loading}</p>
            <Modal title={
                <>
                    <h1 className="text-center mr-top-10">Let's get you setup</h1>
                    <h3 className="text-center">Add your company and work information</h3>
                </>
            } style={{ top: 20 }} width={820} visible={visibleModal} footer={null} onCancel={handleCancel}> 
                {!showsecond ? <>
                    <h2 className="formTitle">Step 1. Basics</h2>
                    <Form {...layout} name="basic" layout="vertical" onFinish={onFinish} validateMessages={validateLabelMessages} validateTrigger='onSubmit'>
                        <Form.Item label="Business Name" name='name' rules={[{ required: true, whitespace: true }]}>
                            <Input autoComplete="off" size="large" />
                        </Form.Item>
                        <div className="wrapper">
                            <Form.Item label="Address" name='address' rules={[{ required: true, whitespace: true }]} className="address">
                                <Input.TextArea style={{ height: 150 }} />
                            </Form.Item>
                            <Form.Item label="City" name='city' rules={[{ required: true, whitespace: true }]} className="city">
                                <Input autoComplete="off" size="large" />
                            </Form.Item>
                            <Form.Item label="State" name='state' rules={[{ required: true, whitespace: true }]} className="state">
                                <Input autoComplete="off" size="large" />
                            </Form.Item>
                        </div>
                        <Form.Item label="Contact Number" name='phoneNumber' rules={[{ required: true, whitespace: true }]}
                        >
                            <Input autoComplete="off" size="large" />
                        </Form.Item>
                        <Form.Item wrapperCol={{ ...layout.wrapperCol }} className="text-center">
                            <Button size="large" type="primary" ghost htmlType="submit" style={{ width: '30%' }}>
                                {loading ? <LoadingOutlined style={{ fontSize: '20px' }} /> : 'Continue (1/3)'}
                            </Button>
                        </Form.Item>
                    </Form>
                </> :
                    <>
                        <h2 className="formTitle">Step 2. License Details</h2>
                        <Form {...layout} name="basic" layout="vertical" onFinish={onFinish} validateMessages={validateLabelMessages} validateTrigger='onSubmit'>
                            <Form.Item name='panNumber' label="Pan No." rules={[]}>
                                <Input autoComplete="off" />
                            </Form.Item>
                            <Form.Item name='binNumber' label="Bin No." rules={[]}>
                                <Input autoComplete="off" size="large" />
                            </Form.Item>
                            <Form.Item name='gstnNo' label="GST No" rules={[{ required: true, whitespace: true }]}
                            >
                                <Input autoComplete="off" size="large" />
                            </Form.Item>
                            <Form.Item name='exporterType' label="Exporter Type" rules={[{ required: true, whitespace: true }]}>
                                <Input autoComplete="off" size="large" />
                            </Form.Item>
                            <Form.Item name='iecNumber' label="IEC No." rules={[{ required: true, whitespace: true }]}
                            >
                                <Input autoComplete="off" size="large" />
                            </Form.Item>
                            <Form.Item wrapperCol={{ ...layout.wrapperCol }} className="text-center">
                                <Button size="large" type="primary" ghost htmlType="submit" style={{ width: '30%' }}>
                                    {loading ? <LoadingOutlined style={{ fontSize: '20px' }} /> : 'Continue (2/3)'}
                                </Button>
                            </Form.Item>
                        </Form>
                    </>}
            </Modal>
        </div>
    );
}
export default CreateCompany